import script from "./AlertasPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertasPanel.vue?vue&type=script&setup=true&lang=js"

import "./AlertasPanel.vue?vue&type=style&index=0&id=a179df7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a179df7c"]])

export default __exports__